<template>
  <div v-if="visible" class="overlay">
    <div class="box">
      <h3>{{ title }}</h3>
      <p>{{ message }}</p>
      <el-button type="primary" @click="confirm">
        Ir a login
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SessionExpiredDialog',
  data() {
    return {
      visible: false,
      title: '',
      message: '',
      onConfirmCb: null
    }
  },
  methods: {
    open(opts = {}) {
      this.title = opts.title || this.title
      this.message = opts.message || this.message
      this.onConfirmCb = typeof opts.onConfirm === 'function' ? opts.onConfirm : null
      this.visible = true
    },
    confirm() {
      this.visible = false
      if (this.onConfirmCb) this.onConfirmCb()
    }
  }
}
</script>

<style scoped>
.overlay{
  position:fixed; inset:0; display:flex; align-items:center; justify-content:center;
  background:rgba(0,0,0,.45); backdrop-filter: blur(6px); z-index:9999;
}
.box{
  background:#fff; padding:20px 24px; border-radius:10px; box-shadow:0 8px 30px rgba(0,0,0,.2); text-align:center;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/tenant/common/SessionExpiredDialog.vue